import React from "react";
import Select from "@streeteasy/design-system/deprecated/Select";
import { addDays } from "date-fns";
import { format, toDate } from "date-fns-tz";
import { func, shape, string } from "prop-types";

import * as S from "./styled";

const tzOptions = { timeZone: "America/New_York" };
const nyNow = toDate(new Date(), tzOptions);

const selectOptions = () => {
  const formattedToday = `Today ${format(nyNow, "MMM d", tzOptions)}`;
  const options = [{ value: formattedToday, label: formattedToday }];

  for (let i = 1; i < 7; i += 1) {
    const date = addDays(nyNow, i);
    const formattedDate = format(date, "EEE MMM d", tzOptions);
    options.push({ value: formattedDate, label: formattedDate });
  }

  return options;
};

const defaultValue = selector =>
  selectOptions().find(option => option.value === selector.date);

const TourDate = ({ datetime, onUpdateDatetime }) => (
  <S.TourDate>
    <Select
      classNamePrefix="tour-date-list"
      defaultValue={defaultValue(datetime)}
      onChange={event => onUpdateDatetime(event, datetime, "date")}
      options={selectOptions()}
      placeholder="Date"
    />
  </S.TourDate>
);

TourDate.propTypes = {
  onUpdateDatetime: func.isRequired,
  datetime: shape({ key: string, date: string, time: string })
};

TourDate.defaultProps = {
  datetime: {}
};

export default TourDate;
